import React, { useContext, useEffect, useState } from 'react'
import { firestore } from '../../firebase';

import StateContext from '../../StateContext'
import AddProfileImage from './AuthorProfile/AddProfileImage';
import AddProfileName from './AuthorProfile/AddProfileName';
import EditProfileDetails from './AuthorProfile/EditProfileDetails'
import EditProfileImage from './AuthorProfile/EditProfileImage'

function EditProfile() {

    const appState = useContext(StateContext);

    const [name, setName] = useState("");
    const [author, setAuthor] = useState()

    useEffect(() => {

        if (appState && appState.userId) {
        
            async function fetchProfile() {

                try {
                    const authorRef = firestore.collection("authors")
                    authorRef.where("user_id", "==", appState.userId).onSnapshot(({docs}) => {
                        if (docs.length > 0) {
                            const author = docs.map(doc => {
                                return {id: doc.id, ...doc.data()}
                            })
                            setAuthor(author[0])
                            setName(author[0].name)
                        }

                    })
                } catch (error) {
                    
                }

            }
            fetchProfile()
        }

    }, [appState.userId])

    if (!appState.loggedIn) return <p>Ikke logget inn</p>

    return (

        <div>
            {author ? (
                <>
                    <h4 className="font-weight-bold my-3">Rediger informasjon</h4>
                    <EditProfileDetails author={author} />
                    <h4 className="font-weight-bold my-3">Rediger profilbilde</h4>
                    <EditProfileImage author={author} />
                </>
            ) 
            :
                <>
                    <h4 className="font-weight-bold">Legg til profil</h4>
                    <AddProfileName />
                </>
            }

            
        </div>

    )
}
export default EditProfile